// Scanbrix workspace location fields (see product app WorkspaceModels.swift).
// `state` stores the city for backward compatibility; `zip_code` is the postal code.

function trimStr(v) {
  if (v == null) return "";
  const s = String(v).trim();
  return s;
}

/** Full location line from a Scanbrix `workspaces` Firestore doc. */
export function formatWorkspaceAddress(d) {
  if (!d || typeof d !== "object") return "";

  for (const k of ["address", "full_address", "fullAddress", "location_address", "locationAddress"]) {
    const v = trimStr(d[k]);
    if (v) return v;
  }

  const loc = d.location || d.site || d.project_location || d.projectLocation;
  if (loc && typeof loc === "object") {
    const nested = formatWorkspaceAddress(loc);
    if (nested) return nested;
  }

  const street = trimStr(d.street ?? d.street_address ?? d.streetAddress);
  const city = trimStr(d.city ?? d.state);
  const zip = trimStr(d.zip_code ?? d.zipCode ?? d.postal_code ?? d.postalCode);
  const country = trimStr(d.country);

  if (!street && !city && !zip) return "";

  const cityZip = [city, zip].filter(Boolean).join(" ");
  const line = cityZip ? (street ? `${street}, ${cityZip}` : cityZip) : street;
  return country ? `${line}, ${country}` : line;
}
